"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query role($roleId: String!) {
    role(roleId: $roleId) {
      _id
      userId
      userEmail
      orgId
      org {
        orgName
        orgLogoUrl
      }
      role
      createdAt
      createdBy
      acceptedAt
      user {
        _id
        firstName
        lastName
        email
      }
    }
  }
`;
exports.default = query;
//# sourceMappingURL=role.query.js.map